import React from "react";
import styles from "./styles.module.scss";

const Tagline = () => {
  return (
    <div className={styles.tagline}>
      <a
        href="https://medpro.vn"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.titleOrg}
      >
        <span className={styles.txt}>Bản quyền thuộc</span>
        <img
          src="https://resource.medpro.com.vn/static/images/medpro/web/header_logo.svg"
          alt=""
        />
      </a>

      <p className={styles.txtOrg}>
        Đặt lịch khám tại Bệnh viện - Phòng khám hàng đầu Việt Nam
      </p>
    </div>
  );
};

export default Tagline;
